import {
  CustomerDataParsed,
  CustomerMapParsed,
  MatchboiError,
} from '../interfaces';
import { Tool } from './base';
//import rison from 'rison-node';

export class ElasticTool extends Tool {
  public readonly toolName = 'Elastic';
  /**
   * Parse Elastic .ndjson export mapping
   * @param elasticExportContents .ndjson newline-delimited JSON file
   */
  public parseMapUpload(elasticExportContents: string): CustomerMapParsed {
    const parsedMap: CustomerMapParsed = [];
    const jsonLines = elasticExportContents.split('\n');

    // check JSON for massive amount of values
    if (jsonLines.length > 5000) {
      throw new MatchboiError('JSON file too large, export invalid?');
    }

    for (const jsonLine of jsonLines) {
      const jsonParsed = JSON.parse(jsonLine);

      if (!('attributes' in jsonParsed)) {
        continue;
      }

      const fields: Array<string> = [];
      for (const fieldJsonParsed of JSON.parse(
        jsonParsed['attributes']['fields']
      )) {
        fields.push(fieldJsonParsed['name']);
      }

      const customerData: CustomerDataParsed = {
        index: jsonParsed['attributes']['title'],
        fields: fields,
      };

      parsedMap.push(customerData);
    }

    return parsedMap;
  }

  /**
   * Stubbed out to disable until sorting out what to do about the "index" keys in the query payload 
  generateSearchPermalink(rootURL: string, renderedContent: string): string {
    const encodedRenderedContent = encodeURIComponent(
      rison.encode(JSON.parse(renderedContent))
    );
    return `${rootURL}discover#/?_g=(filters:!(),refreshInterval:(pause:!t,value:0),time:(from:'now-3h',to:'now'))&_a=(columns:!(),filters:!(('$state':(store:appState),${encodedRenderedContent}),interval:auto,query:(language:kuery,query:''),sort:!(!('@timestamp',desc)))`;
  }
   */
}
